import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const LanguageDropdown = ({ isMobile }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const selectLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    navigate(`/${newLang}`);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isMobile) {
    return (
      <div className="language-selector">
        <button
          className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
          onClick={() => selectLanguage('en')}
        >
          EN
        </button>
        <button
          className={`lang-btn ${lang === 'lv' ? 'active' : ''}`}
          onClick={() => selectLanguage('lv')}
        >
          LV
        </button>
      </div>
    );
  }

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <button className="dropdown-toggle" onClick={toggleDropdown}>
        {lang?.toUpperCase() || 'EN'}
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          <li onClick={() => selectLanguage('en')}>EN</li>
          <li onClick={() => selectLanguage('lv')}>LV</li>
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
